var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getCookie, getCookieEachKeyValue, hashCode, setCookie } from '../utilities/cookies.util';
import settings from "../settings/settings";
var cookieKey = settings.midConfig.cookieKeyPre + settings.midConfig.orgId;
var adobeData = undefined;
export var midPromise = computeMid();
export function getAdobeData() {
    return adobeData;
}
export function computeMid() {
    return __awaiter(this, void 0, void 0, function () {
        var mid, adobeData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (typeof window === "undefined")
                        return [2 /*return*/];
                    mid = getMid();
                    adobeData = { adobeData: getCookie(cookieKey) };
                    if (!(!(mid !== undefined) && !empty(settings) && settings.midConfig.enableMid)) return [3 /*break*/, 3];
                    if (!settings.midConfig.demdexCallEnable) return [3 /*break*/, 2];
                    return [4 /*yield*/, generateMid({ d_ver: 2, d_orgid: settings.midConfig.orgId })];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    generateCookie({ 'd_mid': generateRandomID(), 'isCustom': true });
                    _a.label = 3;
                case 3: return [2 /*return*/, {
                        getMid: getMid,
                        adobeData: adobeData,
                        generateRandomAd: generateRandomAd
                    }];
            }
        });
    });
}
export function generateMid(input) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(settings.midConfig.enableMid && settings.midConfig.serviceUrl)) return [3 /*break*/, 2];
                    return [4 /*yield*/, midCreateService(input).then(function (data) {
                            generateCookie(data);
                        }).catch(function (error) {
                            generateCookie({ 'd_mid': generateRandomID(), 'isCustom': true });
                        })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
}
export function generateCookie(response) {
    var hostname = (document.location && document.location.hostname) ? document.location.hostname : '', cookieDomain = hostname === '' ? '' : (hostname === 'localhost' ? undefined : hostname), fiveYearsFromNow = new Date(new Date().setFullYear(new Date().getFullYear() + 1905)), cookiePath = '/';
    if (cookieDomain) {
        var domainList = cookieDomain.split('.');
        cookieDomain = domainList.length >= 2 ? '.' + domainList[domainList.length - 2] + '.' + domainList[domainList.length - 1] : cookieDomain;
    }
    if (response !== undefined) {
        response = !(typeof response === "object") && JSON.parse(response) || response;
        var SETTINGS_DIGEST = hashCode(settings.midConfig.version + '|' + settings.midConfig.audienceManagerServer + '|' + settings.midConfig.audienceManagerServerSecure), MCMID = (response.d_mid !== undefined) && response.d_mid || generateRandomID(), MCAAMLH = (response.dcs_region !== undefined) && response.dcs_region || '', MCAAMB = (response.d_blob !== undefined) && response.d_blob || '', MCCIDH = '', MCOPTOUT = ((response.d_optout !== undefined) && response.d_optout.toString().toLowerCase() != 'none') && response.d_optout || 'isoptedout-false';
    }
    else {
        response.isSvcInProgress = false;
        response.isCustom = true;
    }
    ;
    var cookiePattern = SETTINGS_DIGEST + '|MCIDTS|17564|MCMID|' + MCMID + '|MCAID|NONE|MCOPTOUT|' + MCOPTOUT + '|MCAAMLH|' + MCAAMLH + '|MCAAMB|' + MCAAMB + '|MCCIDH|' + MCCIDH + '|MCSYNCSOP|411-17568|vVersion|2.3.0';
    cookiePattern = (response && response.isCustom) ? cookiePattern + '|IsCustom|true' : cookiePattern;
    setCookie(cookieKey, cookiePattern, fiveYearsFromNow, cookiePath, cookieDomain);
    adobeData = {
        mid: MCMID ? MCMID : generateRandomID(),
        adobeCookie: cookiePattern
    };
}
export function generateRandomID() {
    var c = '0123456789', d = '', e = '', f, g, i = 10, j = 10;
    for (f = 0; 19 > f; f++)
        g = Math.floor(Math.random() * i), d += c.substring(g, g + 1), 0 === f && 9 == g ? i = 3 : (1 == f || 2 == f) && 10 != i && 2 > g ? i = 10 : 2 < f && (i = 10), g = Math.floor(Math.random() * j), e += c.substring(g, g + 1), 0 === f && 9 == g ? j = 3 : (1 == f || 2 == f) && 10 != j && 2 > g ? j = 10 : 2 < f && (j = 10);
    return d + e;
}
export function generateRandomAd() {
    generateCookie({ 'd_mid': generateRandomID(), 'isCustom': true, 'isSvcInProgress': true });
}
export function getMid() {
    var key = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        key[_i] = arguments[_i];
    }
    var midCookieValue = getCookie(cookieKey), data;
    key = key || settings.midConfig.MCMID;
    data = (midCookieValue !== undefined) && !empty(settings) && settings.midConfig.enableMid && getCookieEachKeyValue(midCookieValue, key) || undefined;
    return data;
}
export function empty(value) {
    var ret = false;
    if (value === null) {
        // typeof null == 'object' so we check it first
        ret = false;
    }
    else if (typeof value === "string" || Array.isArray(value)) {
        ret = !value.length;
    }
    else if (typeof value === "object" || typeof value === "function") {
        var result = true;
        for (var key in value) {
            if (value.hasOwnProperty(key)) {
                result = false;
                break;
            }
        }
        ret = result;
    }
    return ret;
}
export function midCreateService(inputData) {
    return __awaiter(this, void 0, void 0, function () {
        var timeoutFunction, abort;
        return __generator(this, function (_a) {
            settings.serviceConfig['analytics.mid.create.svc'].settings['data'] = inputData;
            abort = false;
            if (settings.midConfig.serviceTimeout) {
                timeoutFunction = setTimeout(function () {
                    abort = true;
                }, settings.midConfig.serviceTimeout);
            }
            try {
                return [2 /*return*/, request(settings.serviceConfig['analytics.mid.create.svc'].settings)];
            }
            catch (_b) {
                if (!abort && timeoutFunction) {
                    clearTimeout(timeoutFunction);
                }
            }
            return [2 /*return*/];
        });
    });
}
;
export function _fetch(options) {
    return __awaiter(this, void 0, void 0, function () {
        var orgOptions, params, fullUrl;
        return __generator(this, function (_a) {
            orgOptions = options, params = orgOptions.data, fullUrl = orgOptions.url;
            if (params) {
                fullUrl += (fullUrl.indexOf('?') === -1 ? '?' : '&') + new URLSearchParams(params).toString();
            }
            return [2 /*return*/, fetch(fullUrl, {
                    cache: 'default',
                    credentials: 'same-origin',
                    headers: orgOptions.headers || {},
                    method: orgOptions.method || orgOptions.type || 'GET',
                    mode: 'cors',
                    redirect: 'follow'
                })
                    .then(function (response) {
                    // convertData only if it is return form DemDex call
                    if (fullUrl.indexOf(settings.svcEndpoint) > -1) {
                        return response;
                    }
                    else {
                        return convertData(response, orgOptions.dataType);
                    }
                })
                    .catch(function (error) {
                    throw (error);
                })];
        });
    });
}
;
export function request(options) {
    var ajaxPromise = fetch && _fetch(options) || _xmlHttpRequest(options);
    return ajaxPromise && ajaxPromise.then(function (response) {
        return response;
    }).catch(function (error) {
        throw (error);
    });
}
;
export function convertData(response, dataType) {
    var converters = {
        'text': function () { return response.text(); },
        'json': function () {
            return response.json().catch(function (err) {
                // If JSON parse fails, attempt to preserve response header info for downstream code
                if (response.headers) {
                    err.headers = response.headers;
                }
                if (response.status) {
                    err.status = response.status;
                    err.statusText = response.statusText;
                }
                throw err;
            });
        }
    };
    if (dataType && converters[dataType] && response) {
        return converters[dataType]();
    }
    return response.text();
}
;
export function _xmlHttpRequest(orgOptions) {
    var _this = this;
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        var params = orgOptions.data;
        if (params && typeof params === 'object') {
            params = new URLSearchParams(orgOptions.data).toString();
        }
        xhr.open(orgOptions.method, orgOptions.url);
        xhr.onload = function () {
            if (_this.status >= 200 && _this.status < 300) {
                resolve(xhr.response);
            }
            else {
                reject({ status: _this.status, statusText: xhr.statusText });
            }
        };
        xhr.onerror = function () {
            reject({ status: _this.status, statusText: xhr.statusText });
        };
        if (orgOptions.headers) {
            Object.keys(orgOptions.headers).forEach(function (key) {
                xhr.setRequestHeader(key, orgOptions.headers[key]);
            });
        }
        xhr.send(params);
    });
}
;
